const data = [{
  uuid: 'd2b45ff9-db51-4e9d-b382-a430eb4b0710',
  name: 'CB-Kennung test',
  code: null,
  type: 'profile',
  required: false,
  input_type: 'select',
  children: [{
    uuid: '2e416f3a-9b62-4d93-8786-018d77bf58c5',
    name: 'CB-Kennung test',
    code: 'CB1J456 _test',
    type: 'profile',
    required: false,
    input_type: 'select',
    children: null,
  }],
}, {
  uuid: '84d96b9c-3a25-42af-930a-367cba83b001',
  name: 'Employee ID',
  code: '',
  type: 'profile',
  required: true,
  input_type: 'text',
  children: null,
}];

export default data;
